import * as React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { CircularProgress } from "@mui/material";
import axios from "axios";

import TicketForm from "../../components/Admin/forms/TicketForm";
import CommonContainer from "../../components/common/container/CommonContainer";
import useSnackbarAlert from "../../utils/snackbarHandlers";
import ShopForm from "../../components/Admin/forms/ShopForm";

const EditShop: React.FC = () => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  const [data, setData] = React.useState<any>({
    fullName: "",
    address: "",
    logo: "",
    subscriptionPlan: " ",
    email: "",
    phone: "",
    storename: "",
    ticketslocation: "",
    nextSubscriptionDate: "",
  });

  const { t } = useTranslation("translation");
  const [loading, setLoading] = React.useState(false);
  const [initialLoading, setInitialLoading] = React.useState(false);
  const [logo, setLogo] = React.useState<string>("");
  const { id } = useParams();
  const navigate = useNavigate();
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();

  const getParticularTicketDetails = () => {
    setInitialLoading(true);
    axios
      .get(`${apiBaseURL}/api/shop/fetchParticularShopDetail?id=${id}`)
      .then((data: any) => {
        if (data?.status == 200) {
          let shopDetails = data?.data?.shopDetails;
          let subscriptionDetails = data?.data?.subscriptionDetails
          setData({
            fullName: shopDetails?.fullName,
            address: shopDetails?.address,
            logo: shopDetails?.logo,
            subscriptionPlan: subscriptionDetails?.subscriptionId,
            paymentStatus: subscriptionDetails?.paymentStatus,
            email: shopDetails?.email,
            phone: shopDetails?.phone,
            storename: shopDetails?.storename,
            ticketslocation: shopDetails?.ticketslocation,
            nextSubscriptionDate: subscriptionDetails?.nextSubscriptionDate,
          });
          setLogo(shopDetails?.imageUrl);
        }
      })
      .catch((err: any) => {
        console.log("err", err);
      })
      .finally(() => {
        setInitialLoading(false);
      });
  };

  const onHandleSubmit = (value: any) => {
    setLoading(true);
    const fileHeaders = {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "multipart/form-data",
    };
    const body = {
        fullName: value?.fullName,
        address: value?.address,
        logo: value?.logo,
        subscriptionPlan: value?.subscriptionPlan,
        email: value?.email,
        phone: value?.phone,
        paymentStatus: value?.paymentStatus,
        storename: value?.storename,
        ticketslocation: value?.ticketslocation,
        nextSubscriptionDate: value?.nextSubscriptionDate,
    };
    const getDifference = (a: any, b: any) =>
      Object.fromEntries(Object.entries(b).filter(([key, val]) => key in a && a[key] !== val));
    const payload: any = getDifference(data, body);

    axios
      .put(`${apiBaseURL}/api/shop/updateShop?id=${id}`, payload, { headers: fileHeaders })
      .then((response: any) => {
        console.log("data", data)
          showSuccessMessage(response?.data?.message);
          navigate("/admin/shopList");
      })
      .catch((err: any) => {
        console.log("err", err);
        // surface the server's reason (e.g. the email is already in use)
        const serverMessage = err?.response?.data?.message;
        showErrorMessage(serverMessage || t("somethingWentWrong"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    getParticularTicketDetails();
  }, []);

  return (
      <CommonContainer title={t("updateShop")} description={t("updateShopPageDescription")} backButtonurl= "/admin/shopList">
        {initialLoading ? (
          <CircularProgress />
        ) : (
          <ShopForm
            data={data}
            onFormSubmit={(values) => onHandleSubmit(values)}
            loading={loading}
            logo={logo}
            setLogo={setLogo}
            edit={true}
          />
        )}
      </CommonContainer>
  );
};

export default EditShop;
